export const CHECKOUT_URL = "https://diabetesbp-en.impultienda.ar/checkout/";

export const images = {
  mockup: "https://cdn.magicpatterns.com/uploads/bYTBLf4K39JYwahP6yqEh1/DIABETEBP-EN.png",
  author: "https://cdn.magicpatterns.com/uploads/tLGNo51RuaLrQ4Ckj7p12C/Dr._Henry_Wells_-_DIABETES.png",
};

export const whatYouGet = [
  { title: "6 Practical Clinical Volumes", text: "A structured reference collection covering the major stages of adult diabetes care." },
  { title: "5 Specialized Clinical Tools", text: "Practical checklists, review sheets, and reference resources designed to support your workflow." },
  { title: "A Visual Decision Framework", text: "An organized way to navigate the material and identify which topic or reference to consult next." },
  { title: "A Practical Consultation Resource", text: "A digital collection designed for quick access, printing, and professional reference." },
  { title: "One-Time Payment: $27", text: "No recurring subscription fees." },
  { title: "Instant Digital Delivery", text: "Access the included materials after your purchase is confirmed." },
];

export const beforeItems = [
  "You spend valuable consultation time searching through different references.",
  "You find yourself reviewing the same topics repeatedly.",
  "You need a clearer way to organize complex patient information.",
  "You want a consistent structure for reviewing treatment considerations.",
  "You worry about overlooking an important follow-up task.",
  "You want to spend less time organizing information and more time focusing on your patients.",
];

export const afterItems = [
  "Navigate the major stages of diabetes care.",
  "Locate relevant educational and clinical references more efficiently.",
  "Organize information before and during consultations.",
  "Review important considerations in a consistent sequence.",
  "Structure follow-up tasks and documentation.",
  "Build a more repeatable workflow around your existing clinical judgment.",
  "Replace scattered references with a structured system.",
];

export const rightForYou = [
  { title: "You spend too much time looking for information.", text: "You know where the guidelines are, but finding the relevant section during a busy clinical day can be frustrating." },
  { title: "Complex patients require more preparation.", text: "You want a structured way to organize the information you need to review when patients present with multiple conditions." },
  { title: "You want a clearer treatment-review workflow.", text: "You need a practical way to organize questions about treatment selection, reassessment, and potential intensification." },
  { title: "You want to structure cardiovascular and kidney risk reviews.", text: "You would benefit from a dedicated reference section for organizing these considerations." },
  { title: "You want a more consistent follow-up process.", text: "You need practical tools for documenting pending tasks, planning reviews, and preparing for future consultations." },
  { title: "You are tired of starting from scratch.", text: "You would rather use a structured collection of professional reference materials than repeatedly create your own notes and checklists." },
];

export const volumes = [
  {
    label: "Volume I",
    title: "The Diagnostic Blueprint",
    subtitle: "Organize the Initial Assessment",
    intro: "A structured reference for reviewing the initial assessment of adults with suspected or established diabetes.",
    items: [
      "An overview of commonly used diagnostic criteria and their appropriate interpretation.",
      "A structured approach to organizing patient history and relevant findings.",
      "A reference section covering differential diagnosis considerations.",
      "An overview of situations that may require additional evaluation.",
      "A checklist for organizing the initial clinical assessment.",
      "A guide to documenting information that requires confirmation.",
    ],
    objective: "Organize the information required for an appropriate assessment without having to build your own reference framework from scratch.",
    note: "Clinical criteria and recommendations must be verified against current guidelines and local requirements.",
  },
  {
    label: "Volume II",
    title: "The Treatment Planning Blueprint",
    subtitle: "Structure Your Therapeutic Review",
    intro: "A practical reference for organizing treatment considerations and individual patient factors.",
    items: [
      "A framework for reviewing individualized treatment goals.",
      "A worksheet for organizing current medications and relevant patient characteristics.",
      "A structured overview of major medication classes used in type 2 diabetes.",
      "A reference framework for reviewing treatment selection considerations.",
      "A worksheet for documenting questions about reassessment and treatment intensification.",
      "A checklist for reviewing the information needed before making treatment decisions.",
    ],
    objective: "Make treatment reviews more organized, consistent, and easier to document.",
    note: "The material supports clinical review and does not replace individualized prescribing decisions.",
  },
  {
    label: "Volume III",
    title: "The Cardiovascular Protection Blueprint",
    subtitle: "Organize Risk Considerations",
    intro: "A dedicated reference for structuring the review of cardiovascular risk and related treatment considerations.",
    items: [
      "A framework for organizing cardiovascular history and risk factors.",
      "A checklist for identifying information that requires review.",
      "A visual overview of relevant medication classes and their clinical roles.",
      "A structured reference for organizing cardiovascular risk discussions.",
      "A worksheet for documenting treatment considerations.",
      "A follow-up planning template.",
    ],
    objective: "Give cardiovascular considerations a clear place within your consultation workflow.",
    note: "Specific recommendations must be checked against current evidence, prescribing information, and applicable guidelines.",
  },
  {
    label: "Volume IV",
    title: "The Kidney Care Blueprint",
    subtitle: "Structure Renal Risk Reviews",
    intro: "A practical reference focused on organizing kidney-related information in adults with diabetes.",
    items: [
      "A worksheet for organizing relevant kidney assessment data.",
      "A reference overview of estimated glomerular filtration rate and albuminuria.",
      "A structured framework for reviewing kidney-related risk.",
      "A medication-review checklist.",
      "A worksheet for documenting questions about renal function and treatment suitability.",
      "A follow-up planning template for kidney-related considerations.",
    ],
    objective: "Organize renal information and make relevant review questions easier to identify.",
    note: "Any medication-specific thresholds, dose adjustments, or prescribing recommendations require professional validation against current product information and applicable guidelines.",
  },
  {
    label: "Volume V",
    title: "The Insulin Management Blueprint",
    subtitle: "Organize Insulin-Related Decisions",
    intro: "A structured educational reference for reviewing the major considerations involved in insulin therapy.",
    items: [
      "An overview of situations in which insulin therapy may need to be considered.",
      "A worksheet for organizing relevant patient information.",
      "A structured reference to basal and other insulin regimens.",
      "A framework for documenting treatment-review questions.",
      "A checklist for organizing hypoglycemia-related considerations.",
      "A worksheet for documenting follow-up and reassessment needs.",
    ],
    objective: "Organize the information required to review insulin-related decisions and support a consistent documentation process.",
    note: "Patient-specific insulin initiation, dosing, and titration must follow current clinical guidance and individualized professional judgment.",
  },
  {
    label: "Volume VI",
    title: "The Long-Term Care Blueprint",
    subtitle: "Organize Follow-Up and Monitoring",
    intro: "A practical framework for organizing ongoing diabetes care.",
    items: [
      "A structured overview of long-term follow-up considerations.",
      "A checklist for organizing periodic reviews.",
      "A worksheet for tracking pending assessments.",
      "A framework for documenting individualized goals.",
      "A reference section covering common complication-screening considerations.",
      "A template for preparing the next consultation.",
    ],
    objective: "Establish a more consistent structure for reviewing outstanding tasks and preparing future consultations.",
    note: "",
  },
];

export const bonuses = [
  {
    label: "Bonus #1",
    title: "The Renal Medication Review Matrix",
    image: "https://cdn.magicpatterns.com/uploads/8J64erRp9hkzy3fUbo9iRo/BONUS_1_DIABETESBP-EN.png",
    text: "A structured reference for organizing medication reviews in patients with impaired kidney function. Document renal-function information, identify medication-review questions, and record which prescribing references need to be consulted.",
    items: ["A renal medication review worksheet.", "A structured list of information to collect.", "A medication verification checklist.", "A reference-tracking section.", "A documentation template."],
    value: 19,
  },
  {
    label: "Bonus #2",
    title: "The Insulin Consultation Planner",
    image: "https://cdn.magicpatterns.com/uploads/kEuwsv7JenLXySAcqg2BQM/BONUS_2_DIABETESBP-EN.png",
    text: "A practical worksheet for organizing insulin-related consultations and follow-up. Structure patient information, document relevant questions, and prepare for treatment reviews.",
    items: ["An insulin consultation worksheet.", "A patient-information review checklist.", "A treatment-discussion template.", "A follow-up documentation sheet.", "A hypoglycemia-related review checklist."],
    value: 19,
  },
  {
    label: "Bonus #3",
    title: "The Annual Diabetes Review Checklist",
    image: "https://cdn.magicpatterns.com/uploads/x1L5PhCBui6TqvsJU8HfoD/BONUS_3_DIABETESBP-EN.png",
    text: "A structured checklist for organizing periodic diabetes assessments — review which assessments, records, and follow-up tasks need attention according to the patient's circumstances and the applicable care protocol.",
    items: ["A periodic review checklist.", "A complication-screening review section.", "A medication review section.", "A record of pending assessments.", "A next-visit planning sheet."],
    value: 17,
  },
  {
    label: "Bonus #4",
    title: "The Patient Conversation Framework",
    image: "https://cdn.magicpatterns.com/uploads/ur4fwY3bummTxcF9LDN5kZ/BONUS_4_DIABETESBP-EN.png",
    text: "Clear communication is an important part of diabetes care. Organize conversations around patient concerns, treatment expectations, adherence, and shared decision-making.",
    items: ["A consultation conversation outline.", "Questions for exploring patient concerns.", "A framework for discussing treatment options.", "A worksheet for documenting shared decisions.", "A follow-up conversation planner."],
    value: 15,
  },
  {
    label: "Bonus #5",
    title: "The Clinical Review & Documentation Checklist",
    image: "https://cdn.magicpatterns.com/uploads/xwFnEqhoAvR7RiNPCkE5wV/BONUS_5_DIABETESBP-EN.png",
    text: "A structured checklist for reviewing relevant information before finalizing your clinical documentation. Organize the information reviewed, identify unresolved questions, and document the next steps.",
    items: ["A clinical information review checklist.", "A documentation completeness checklist.", "A source-verification worksheet.", "A pending-question register.", "A next-step documentation template."],
    value: 17,
  },
];

export const included = [
  "Six practical clinical reference volumes",
  "A diagnostic assessment framework",
  "A treatment-review framework",
  "Cardiovascular risk review resources",
  "Kidney-related assessment resources",
  "Insulin consultation references",
  "Long-term follow-up materials",
  "Five specialized clinical tools",
  "Printable checklists and worksheets",
  "A structured navigation system",
];

export const testimonials = [
  {
    name: "Dr. Sarah Jensen",
    role: "Family Physician · Ohio, USA",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/5d48226a-b4af-424e-b734-f38078a3b64e.jpg",
    quote: "I used to keep a dozen tabs open during clinic. Now I open the volume I need and the worksheet is right there. My follow-up notes are far more consistent than they were a month ago.",
  },
  {
    name: "Dr. Michael Harper",
    role: "Internal Medicine · Texas, USA",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/74dda4c8-e71d-4a03-ae63-d386f4cb7660.jpg",
    quote: "The Kidney Care volume and the Renal Medication Review Matrix alone were worth it. It gives me a clean sequence of questions to check before I sign off on a medication review.",
  },
  {
    name: "Danielle Brooks, NP",
    role: "Primary Care · Georgia, USA",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/5ac08e27-146b-4256-bd9e-95e8f1da446e.jpg",
    quote: "The Annual Review Checklist is now printed and sitting on my desk. I stopped worrying about missing a pending assessment because everything has a place.",
  },
  {
    name: "Dr. Arjun Mehta",
    role: "Endocrinology Resident · New Jersey, USA",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/f982bc68-9f88-4b99-8993-54ebe92ca4e4.jpg",
    quote: "As a resident, the structure is what I needed most. Instead of rebuilding my own notes for every rotation, I follow the framework and focus on the patient in front of me.",
  },
];

export const faqs = [
  { q: "How will I receive Diabetes Clinical Blueprint?", a: "After your payment is confirmed, you'll receive instructions for accessing and downloading the included digital materials." },
  { q: "Is the material suitable for clinicians in different countries?", a: "The collection is intended as an educational reference for healthcare professionals. Clinical recommendations, medication availability, prescribing requirements, and local protocols vary by country. You should verify clinical information against the guidelines and regulations applicable to your practice." },
  { q: "Do I need to be an endocrinologist?", a: "The materials are intended for qualified healthcare professionals involved in adult diabetes care. Your professional scope, training, and local regulations determine which clinical activities you may perform." },
  { q: "Can I access the materials on my phone?", a: "The digital documents can be opened on compatible devices and PDF readers. Some layouts may be easier to review on a larger screen or in printed form." },
  { q: "Are the files downloadable?", a: "Yes. The collection is delivered digitally for download, subject to the delivery instructions provided after purchase." },
  { q: "Is this a recurring subscription?", a: "No. The offer is a one-time payment of $27 for the included edition. No monthly subscription is required." },
  { q: "Does the Blueprint replace official clinical guidelines?", a: "No. It is an educational reference and organizational tool. It does not replace current clinical guidelines, official prescribing information, professional training, individualized assessment, or clinical judgment." },
  { q: "What if the product isn't right for me?", a: "Your purchase is covered by the stated seven-day money-back guarantee. Contact us within the guarantee period to request a refund under the applicable terms." },
];

export const buyers = [
  { name: "María González", country: "Mexico" },
  { name: "Carlos Ramírez", country: "Colombia" },
  { name: "Lucía Fernández", country: "Argentina" },
  { name: "José Martínez", country: "Spain" },
  { name: "Valentina Rojas", country: "Chile" },
  { name: "Andrés Torres", country: "Peru" },
  { name: "Camila Herrera", country: "Ecuador" },
  { name: "Diego Morales", country: "Guatemala" },
  { name: "Sofía Castillo", country: "Uruguay" },
  { name: "Javier Ortega", country: "Dominican Republic" },
  { name: "Daniela Vargas", country: "Costa Rica" },
  { name: "Mateo Silva", country: "Venezuela" },
  { name: "Isabel Navarro", country: "Puerto Rico" },
  { name: "Ricardo Méndez", country: "Panama" },
];
